import { render, staticRenderFns } from "./video-form.vue?vue&type=template&id=b89bcb5a&"
import script from "./video-form.vue?vue&type=script&lang=js&"
export * from "./video-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports